/**
 * @generated SignedSource<<1743e32465935cc36a59de9997664970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_authenticationConfig",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuDesktop_authenticationConfig"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuMobile_authenticationConfig"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithSimpleMenu_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "3bdb4e0a0848c0ad04bf82a255798bff";

module.exports = node;
